import {
  BrandKit,
  ButtonOptionsOverride,
} from "@redotech/redo-content-builder-common/brand-kit";
import { getButtonStyles } from "@redotech/redo-content-builder-common/brand-kit/utils";
import {
  ButtonHierarchy,
  ButtonStyleOverride,
} from "@redotech/redo-content-builder-common/element-schema";
import classNames from "classnames";
import { memo } from "react";
import {
  RedoButton,
  RedoButtonHierarchy,
  RedoButtonProps,
} from "./arbiter-components/buttons/redo-button";
import * as css from "./brand-kit-button.module.css";

const hierarchyLiteralToEnum: Record<string, RedoButtonHierarchy> = {
  primary: "primary",
  secondary: "secondary",
  tertiary: "tertiary",
} as const;

export const BrandKitButton = memo(function BrandKitButton({
  brandKit,
  globalOverride,
  elementOverride,
  hierarchy,
  ...props
}: Omit<RedoButtonProps, "hierarchy" | "style" | "ref"> & {
  brandKit: BrandKit;
  globalOverride?: ButtonOptionsOverride;
  elementOverride?: ButtonStyleOverride | null;
  hierarchy: ButtonHierarchy;
}) {
  const style = getButtonStyles({
    brandKit,
    hierarchy,
    globalOverride: globalOverride?.[hierarchy],
    elementOverride,
    fullWidth: true,
  });

  return (
    <RedoButton
      {...props}
      className={classNames(
        props.className,
        css.brandKitButton,
        css[hierarchy],
      )}
      dangerousStyleThatShouldOnlyBeUsedForMerchantBranding={style}
      hierarchy={hierarchyLiteralToEnum[hierarchy]}
    />
  );
});
